import { AUTO_LOGOUT_TIME } from './apiurl';
import { userActions } from '../Actions/useractions';
import { store } from 'Store';
import { decryptUserToken } from '.';
let autoLogoutTimer = null;

export const AutoLogout = () => {
    clearTimeout(autoLogoutTimer);
    const user = decryptUserToken()
    if(user) {
        autoLogoutTimer = setTimeout(() => {
            store.dispatch(userActions.logout(true));
            clearTimeout(autoLogoutTimer);
        }, AUTO_LOGOUT_TIME);
    }
}

export const ClearAutoLogout = () => {
    clearTimeout(autoLogoutTimer);
}